import { retryWhen, share, tap, scan, map, skipWhile, finalize, shareReplay, takeUntil } from 'rxjs/operators';
import { Observable, Subscriber, concat } from 'rxjs';
import { setPubsubStream, errorHandler, shareSubjectWithDelay } from '../apiHelper';
import { ProcessType, WinCCArea, WinCCMessage, WinCCbserverModel, GroupedWinCCMessages } from '../../types';
import { default as lodashMerge } from 'lodash/merge';
import { getWinCCInitialData } from './WinCCInitialServices';
import { getFactoryChangeObservable } from '../../Auth';

const WinCCObserver: WinCCbserverModel = {
    winCCObservable: null as Observable<GroupedWinCCMessages>,
};

const setWinCCStream = () => new Observable<WinCCMessage>((observer: Subscriber<WinCCMessage>) => {
    const close = setPubsubStream(observer, ProcessType.WINCC);
    return close;
}).pipe(
    retryWhen(errorHandler),
    takeUntil(getFactoryChangeObservable()),
    tap(data => (global as any).PMI_LOGS && console.debug('WINCC', data)),
    share()
);

const WinCCDataObservable = () => {
    WinCCObserver.winCCObservable = concat(
        getWinCCInitialData(),
        setWinCCStream(),
    ).pipe(
        skipWhile(data => !data && !Object.values(data).length),
        scan((acc, val) => lodashMerge({}, acc, { [val.msgNr]: val }), {} as GroupedWinCCMessages),
        map(removeOldWinCCMessages),
        finalize(() => WinCCObserver.winCCObservable = null),
        shareReplay({
            bufferSize: 1,
            refCount: true,
        })
    )
    return WinCCObserver.winCCObservable
};

const getWinCCDataObservable = (): Observable<GroupedWinCCMessages> =>
    WinCCObserver.winCCObservable
        ? WinCCObserver.winCCObservable
        : WinCCDataObservable();

const sortItem = (a: WinCCMessage, b: WinCCMessage) => {
    return b.localtime - a.localtime
};

const removeOldWinCCMessages = (data: GroupedWinCCMessages) => {
    return Object.values(data).reduce((acc, val) => {
        if (val.status !== 1) {
            return acc;
        }
        return Object.assign({}, acc, { [val.msgNr]: val });
    }, {} as GroupedWinCCMessages)
};

export const getINTBWinCCMessages = () => shareSubjectWithDelay(getWinCCDataObservable().pipe(
    map(data => Object.values(data).sort(sortItem) as WinCCMessage[]),
    map(data => data.filter(el => el.area === WinCCArea.INTB)),
));

export const getTBCFWinCCMessages = () => shareSubjectWithDelay(getWinCCDataObservable().pipe(
    map(data => Object.values(data).sort(sortItem) as WinCCMessage[]),
    map(data => data.filter(el => el.area === WinCCArea.TBCF)),
));